import { makeStyles } from '@mui/styles';

const divider = '1px solid rgba(10,13,18,0.10)';

const useStyles = makeStyles(() => ({
  pageWrapper: {
    display: 'flex',
    padding: '0 24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '24px',
    alignSelf: 'stretch',
    marginBottom: '50px'
  },
  headerWrapper: {
    display: 'flex',
    padding: '32px 0',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch'
  },
  headerColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '32px',
    flex: '1 0 0'
  },
  headerTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxWidth: '500px'
  },
  summaryHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },

  cardRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px'
  },
  revenueCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    alignSelf: 'stretch'
  },
  priceTitleCard: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxWidth: '500px'
  },
  priceCard: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px',
    alignSelf: 'stretch'
  },
  priceContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    flex: '1 0 0'
  },
  priceValue: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch'
  },

  summaryTable: {
    marginTop: 8,
    tableLayout: 'fixed',
    width: '100%'
  },
  headRow: {
    '& th': {
      borderBottom: divider,
      paddingBottom: 12
    }
  },
  headCellLeft: {
    wordWrap: 'break-word',
    whiteSpace: 'normal'
  },
  headCell: {
    wordWrap: 'break-word',
    whiteSpace: 'normal'
  },
  bodyRow: {
    '& td': {
      borderBottom: divider,

      wordWrap: 'break-word',
      whiteSpace: 'normal'
    }
  },
  bodyRowLast: {
    '& td': {
      borderBottom: divider,

      wordWrap: 'break-word',
      whiteSpace: 'normal',
      verticalAlign: 'top'
    }
  },
  bodyRowWithSeparation: {
    '& td': {
      borderBottom: divider,

      wordWrap: 'break-word',
      whiteSpace: 'normal',
      verticalAlign: 'top'
    }
  },
  totalRow: {
    '& td': {
      borderBottom: divider,

      wordWrap: 'break-word',
      whiteSpace: 'normal',
      verticalAlign: 'top',
      fontWeight: 600
    }
  },
  labelCell: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    maxWidth: 0,
    overflow: 'hiden'
  },
  amountCell: {
    paddingRight: 16,
    textAlign: 'right',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    minWidth: '100px',
    maxWidth: '40%'
  },

  card: {
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    flex: '1 0 0',
    backgroundColor: '#FFF',
    boxShadow: '0px 1px 2px 0 rgba(10, 13, 18, 0.05)',
    borderRadius: '12px',
    border: '1px solid #FFF'
  },
  tableCellContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px'
  },
  brandContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    borderRadius: '12px'
  },
  brandHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  brandInputs: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
    alignSelf: 'stretch'
  },
  baseTypographySx: {
    fontSize: '0.875rem',
    fontWeight: '600 !important',
    color:
      'var(--M3-sys-light-on-surface, var(--Schemes-On-Surface, #1D1B20)) !important',
    minWidth: '40px !important'
  },

  '@media (max-width: 640px)': {
    pageWrapper: {
      padding: '0px',
      gap: '16px'
    },
    headerWrapper: {
      padding: '24px 0'
    },
    summaryHeader: {
      gap: '12px'
    },
    cardRow: {
      gap: '12px'
    },
    priceCard: {
      gap: '12px'
    },
    summaryTable: {
      display: 'block',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch'
    },
    headCellLeft: {
      paddingRight: 8
    },
    headCell: {
      paddingRight: 8
    },

    amountCell: {
      paddingRight: 8
    },
    brandInputs: {
      gridTemplateColumns: '1fr',
      gap: '16px'
    },
    mobileRegionsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    },
    mobileRegionHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    mobileRegionBody: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      marginTop: '12px'
    },
    mobileRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 0'
    },
    mobileRowLabel: {
      paddingRight: 8
    },
    mobileRowValue: {
      textAlign: 'right'
    },
    mobileTotalRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: '12px',
      fontWeight: 600
    }
  }
}));

export default useStyles;
